import { ApiMethod } from '../apimethods/api-method';
import * as ngswal from "sweetalert";
import { GlobalConstants } from './global-constants';
import { EADDRINUSE } from 'constants';
declare var $;


export class DataParam {
  acolList: any;
  aNewButtonName: any; aNewButtonName1: any;
  aNewButtonToolTip: string; aNewButtonToolTip1: string;
  aNewButtonName2: any; aNewButtonToolTip2: string;
  aNewButtonName3: any; aNewButtonToolTip3: string;
  dataTable: any;
  dataset: any;
  dtheight: any;
  modulename: any = '';
  infoPopupID: any = '';
  isDefault: boolean = false;
  colsetting: boolean = true;
  filterPanel: boolean = false;
  searchButton: boolean = true;
  rowSelect: boolean = false;
  contextMenu: boolean = false;
  defaultPagesize: number = 25;
  LengthChange: boolean = true;
  IdOrder: string = "asc";
  ExportFileName: string = "";
  StateSave: boolean = false;
  ResponsiveMode: boolean = false;
  FooterCallback: boolean = false;
  FooterSummaryStartIndex: number = 2;
  FooterSummaryEndIndex: number = 5;
  FooterSummaryAvgStart: number = 0;
  FooterSummaryAvgEnd: number = 0;
  HideFreshButton: boolean = false;
  HideUploadButton: boolean = false;
}

export class customfunctions {

  public static dynamicColumns(acolList, aNewButtonName) {
    let columnsList = []; let exprtcol = []; let buttonList = [];

    $.each(acolList, function (e, val) {
      // Dynamic Columns
      if (val.Actions == 0) {
        columnsList.push({ title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable });
        exprtcol.push(e);
      }
      else {
        // Dynamic Columns Actions item
        if (val.ActionsItems.toString().indexOf('Report') > -1) {
          columnsList.push({
            title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable,
            render: function (data, type, full, meta) {
              return '<span class=spUpdateIcon>' +
                '<i class="bx bxs-file" style="color: blue;" title="Report" onclick=' + "localStorage.dtColName='" + val.ColumnData + "';" + 'localStorage.aEID=' + data + ';$("#' + aNewButtonName + '").trigger("click");></i></span>';
            }
          });
        }
        else if (val.ActionsItems.toString().indexOf('Update') > -1) {
          columnsList.push({
            title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable,
            render: function (data, type, full, meta) {
              return '<span class=spUpdateIcon>' +
                '<i class="bx bxs-edit-alt" style="color: blue;" title="Edit" onclick=' + "localStorage.dtColName='" + val.ColumnData + "';" + 'localStorage.aEID=' + data + ';$("#' + aNewButtonName + '").trigger("click");></i></span>';
            }
          });
        }
        else {
          columnsList.push({ title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable });
        }
      }
    });

    let exportFileName = acolList[0].ModuleName + '_' + GlobalConstants.CurrentDateWithTime();
    if (acolList[0].ExportExcel == 1) {
      buttonList.push({
        extend: 'excelHtml5',
        text: '<img src="../../../assets/Images/excel.png" title="Export to Excel" />',
        filename: exportFileName,
        title: acolList[0].ModuleName,
        exportOptions: {
          columns: exprtcol,
        }
      });
    }
    if (acolList[0].ExportPDF == 1) {
      buttonList.push({
        extend: 'pdfHtml5',
        text: '<img src="../../../assets/Images/pdf.png" title="Export to PDF" />',
        filename: exportFileName,
        title: acolList[0].ModuleName,
        orientation: 'landscape',
        pageSize: 'LEGAL',
        exportOptions: {
          columns: exprtcol,
        }
      });
    }
    if (acolList[0].ExportCSV == 1) {
      buttonList.push({
        extend: 'csvHtml5',
        text: '<img src="../../../assets/Images/csv.png" title="Export to CSV" />',
        filename: exportFileName,
        title: acolList[0].ModuleName,
        exportOptions: {
          columns: exprtcol,
        }
      });
    }
    if (acolList[0].ActionsItems.toString().indexOf('Add') > -1) {
      buttonList.push({
        text: '<button class="btn btn-outline-info waves-effect waves-light spAddIcon"><i class="fa fa-plus"></i> Add</button>',
        action: function (e, dt, node, config) {
          localStorage.aEID = 0;
          $("#btn_AddNew").trigger("click");

        }
      });
    }
    return [columnsList, exprtcol, buttonList];
  }

  public static dynamicDataTable(paramItem: DataParam) {
    let columnsList = []; let exprtcol = []; let buttonList = []; var datetimecolumnsList = [];
    let colcenterList = []; let colrightList = [];
    localStorage.mdName = paramItem.modulename;
    localStorage.metadataEdit = true;
    localStorage.selectRowIdVal = "";
    localStorage.dropId = "";
    //Context menu details
    try { $.contextMenu('destroy'); } catch (e) { }
    var contextitem = {};
    let aColumnList = '';

    if (paramItem.acolList.length == 0) {
      ngswal("Warning !", "No Column list Allocated !", "warning");
      return paramItem.dataTable;
    }
    //Check Edit Action available for Metadata editing
    var menuList = JSON.parse(localStorage.aMenuList);
    var chkActionOption = menuList.filter(a => a.MenuName == "MetaData");
    if (chkActionOption.length == 0) {
      localStorage.metadataEdit = false;
    }
    else {
      if (chkActionOption[0].Action.toString() == 'View') {
        localStorage.metadataEdit = false;
      }
    }

    //Grid Serial No Column added
    let showGridSNo = false;
    var chkShowGridSerialNo = menuList.filter(a => a.MenuName == "ShowGridSerialNo");
    if (chkShowGridSerialNo.length > 0) {
      if (chkShowGridSerialNo[0].Action.toString() == 'View') {
        showGridSNo = true;
      }
    }

    if (showGridSNo) {
      columnsList.push({
        "title": "#",
        render: function (data, type, row, meta) {
          return meta.row + meta.settings._iDisplayStart + 1;
        }
      });
      exprtcol.push(columnsList);
    }

    //Dynamic Column Push
    $.each(paramItem.acolList, function (e, val) {
      //Columns List load
      if (val.ColumnTitle != 'Action' && val.ColumnTitle != 'Actions' && val.ColumnTitle != 'OverDueCSS' && val.ColumnTitle != 'ToolTipMessage'
        && val.ColumnTitle != 'StageCss' && val.ColumnTitle != 'AllocatedUserId') {
        let Ischecked = (val.Visible ? 'checked' : '');
        aColumnList += "<div class='col divCOList'><input class='chkCOAction' type='checkbox' " + Ischecked + " name='" + val.ColumnTitle + "'  />" + val.ColumnTitle + " </div>";
      }
      $('#divColumnsList').html(aColumnList);

      //chkCOAction checkbox change event
      $('.chkCOAction').change(function () {
        var chkCOActionCt = $('input.chkCOAction:checked').length;
        if (chkCOActionCt <= 2) {
          if (!$(this).is(':checked')) {
            $(this).prop('checked', 'checked');
            ngswal("Info !", "Minimum 3 columns should be display !", "info");
          }
        }
      });


      // Dynamic Columns
      if (val.ColumnReturnData == 'WebLink') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            let colorCode = '#556ee6';
            return "<span class='spCol spPopup' style='cursor: pointer !important; color: " + colorCode + "; text-decoration: underline;width: auto !important;'  onclick=window.open('" + data + "');>" + data + "</span>";
          }
        });
        exprtcol.push(e);
      }
      else if (val.ColumnReturnData == 'WebLinkIcon') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            let colorCode = '#556ee6';
            return "<span style='cursor:pointer!important;' title='BookIn Trigger' onclick=window.open('" + data + "');><i style='important;color:green;' class='fa fa-check' aria-hidden='true'></i></span>";
          }
        });
        exprtcol.push(e);
      }
      else if (val.ColumnReturnData == 'InfoPoup') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            let dataTitle = data; let colorCode = '#556ee6'; let readonly = '';
            if (full["ToolTipMessage"] != null) {
              dataTitle = full["ToolTipMessage"];
              colorCode = '#1e79b1'; //set grayout
              readonly = "localStorage.metadisable=false;";
            }
            if (val.ActionsItems.toString().indexOf('Update') == -1) {
              readonly = "localStorage.metadisable=false;";
            }
            if (paramItem.infoPopupID != '' && full[paramItem.infoPopupID] != null) {

              if (full[val.ColumnData + 'Title'] != null) {
                let _dataTitle = full[val.ColumnData + 'Title'];
                let _title = 'Target achieved: ' + data + '% (' + data + '% of ' + _dataTitle + '%)';
                dataTitle = _title;
              }

              return `<span class='spCol spPopup'
                        style='cursor: pointer !important;color:${colorCode};text-decoration:underline;width:auto !important;'
                        title='${dataTitle}'
                        onclick="${readonly}
                        localStorage.aEID='${full[paramItem.infoPopupID]}';
                        localStorage.mdName='${paramItem.modulename}';
                        localStorage.dtColName='${val.ColumnData}';
                        localStorage.clicktype='spanpopup';
                        $('#btnPopupDT').trigger('click');">${data}</span>`;
            }
            else {
              return `<span class='spCol spPopup' style='cursor:pointer !important;color:##556ee6;text-decoration:underline;width:auto !important;' title='${dataTitle}'>${data}</span>`;
            }
          }
        });
        if (val.ColumnDataType == 'datetime') {
          datetimecolumnsList.push(e + 1);
        }
        exprtcol.push(e);
      }
      else if (val.ColumnReturnData == 'TransforResindEdit') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Transfer') > -1) {
              contextitem['Transfer'] = { name: "Transfer", icon: "bx bx-transfer-alt" };
            }
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Resigned') > -1) {
              contextitem['Resigned'] = { name: "Resigned", icon: "bx bx-x" };
            }
            return "<span class=spDTIcon>" +
              "<i class='bx bx-transfer-alt' style='color: #152ca3; font-size: 20px; title='Transfer' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='TransferPopup';" + "$('#btnTransferDT').trigger('click');></i>" +
              "<i class='bx bx-x' style='color: #f13a3a; font-size: 20px; title='Resigned' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='ResignedPopup';" + "$('#btnResignedDT').trigger('click');></i>" +
              "<i class='bx bxs-edit-alt' style='color: #18ba32; font-size: 20px; title='Info' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='ipopup';" +
              "$('#btnPopupDT').trigger('click');></i>" +
              "</span>";
          }
        });
      }
      else if (val.ColumnReturnData == 'InfoPoupThreshold') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            let dataTitle = data; let colorCode = '#556ee6'; let readonly = '';
            if (full["ToolTipMessage"] != null) {
              dataTitle = full["ToolTipMessage"];
              colorCode = '#1e79b1'; //set grayout
              readonly = "localStorage.metadisable=false;";
            }
            if (val.ActionsItems.toString().indexOf('Update') == -1) {
              readonly = "localStorage.metadisable=false;";
            }
            if (paramItem.infoPopupID != '' && full[paramItem.infoPopupID] != null) {
              let _chkPercentage: number = 100;
              if (full[val.ColumnData + 'Title'] != null) {
                _chkPercentage = parseInt(full[val.ColumnData + 'Title']);
              }
              let _cellClass = 'spColRed';
              if (parseInt(data) >= _chkPercentage) {
                _cellClass = 'spColGreen';
              }

              if (full[val.ColumnData + 'Title'] != null) {
                let _dataTitle = full[val.ColumnData + 'Title'];
                let _title = 'Target achieved: ' + data + '% (' + data + '% of ' + _dataTitle + '%)';
                dataTitle = _title;
              }

              return "<span class='" + _cellClass + " spPopup' style='cursor: pointer !important; color: " + colorCode
                + "; text-decoration: underline;' title='" + dataTitle + "'"
                + "onclick=" + readonly + "localStorage.aEID='" + full[paramItem.infoPopupID] + "';"
                + "localStorage.mdName='" + paramItem.modulename + "';"
                + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.clicktype='spanpopup';"
                + "$('#btnPopupDT').trigger('click');>" + data + "</span>";
            }
            else {
              return "<span class='spCol spPopup' style='cursor: pointer !important; color: ##556ee6; text-decoration: underline;width: auto !important;' title='" + dataTitle + "'>" + data + "</span>";
            }
          }
        });
        if (val.ColumnDataType == 'datetime') {
          datetimecolumnsList.push(e + 1);
        }
        exprtcol.push(e);
      }
      else if (val.ColumnReturnData == 'MinWidth') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            return "<span class='spCol spPopup'  title='" + data + "'>" + data + "</span>";
          }
        });
        exprtcol.push(e);
      }
      else if (val.ColumnReturnData == 'TextWrap') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            return `<span style="white-space: pre-wrap;" title='${data}'>${data}</span>`;
          }
        });
        exprtcol.push(e);
      }
      else if (val.ColumnReturnData == 'Report') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            var returnData = '';
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Report') > -1) {
              contextitem['Report'] = { name: "Report", icon: "bx bxs-file" };
              returnData += "<span class=spReportIcon>" +
                "<i class='bx bxs-file' title='Report' style='color:#34c38f;font-size:25px;' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='ReportView';"
                + "$('#btnReportView').trigger('click');></i></span>";
            }
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('DocDownload') > -1) {
              contextitem['DocDownload'] = { name: "WordDownload", icon: "fa fa-file-wordcode" };
              returnData += "<span class=spWordIcon>" +
                "<i class='bx bxs-file-doc' title='Word Download' style='color:#1f457e;font-size:25px;' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='ReportView';"
                + "$('#btnDocDownload').trigger('click');></i></span>";
            }
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('DocUpload') > -1) {
              contextitem['DocUpload'] = { name: "WordUpload", icon: "fa fa-file-upload" };
              returnData += "<span class=spWordIcon>" +
                "<i class='bx bx-upload' title='Word Upload' style='color:#1f457e;font-size:25px;' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='ReportView';"
                + "$('#btnDocUpload').trigger('click');></i></span>";
            }

            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('DocMerge') > -1) {
              contextitem['WordMerge'] = { name: "WordMerge", icon: "fa fa-file-clone" };
              returnData += "<span class=spWordIcon>" +
                "<i class='bx bxs-book-content' title='Word Merge' style='color:#50a5f1;font-size:25px;' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='ReportView';"
                + "$('#btnDocMerge').trigger('click');></i></span>";
            }

            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('HtmlDownload') > -1) {
              contextitem['HtmlDownload'] = { name: "HtmlDownload", icon: "fa fa-file-code" };
              returnData += "<span class=spWordIcon>" +
                "<i class='bx bxs-file-html' title='Html Download' style='color:#74788d;font-size:25px;' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='ReportView';"
                + "$('#btnHtmlDownload').trigger('click');></i></span>";
            }

            return returnData;
          }
        });
        exprtcol.push(e);
      }
      else if (val.ColumnReturnData == 'Download') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Download') > -1) {
              contextitem['download'] = { name: "Download", icon: "bx bx-download" };
            }
            return "<span class=spDTIcon>" +
              "<i class='bx bx-download' title='download' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='downloadPopup';"
              + "$('#btnDownloadDT').trigger('click');></i></span>";
          }
        });
      }
      else if (val.ColumnReturnData == 'Upload') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Upload') > -1) {
              contextitem['upload'] = { name: "Upload", icon: "bx bx-upload" };
            }
            return "<span class=spDTIcon>" +
              "<i class='bx bx-upload' title='Upload' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='uploadPopup';"
              + "$('#btnUploadDT').trigger('click');></i></span>";
          }
        });
      }
      else if (val.ColumnReturnData == 'DownloadUploadInfo') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Download') > -1) {
              contextitem['download'] = { name: "Download", icon: "bx bx-download" };
            }
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Upload') > -1) {
              contextitem['upload'] = { name: "Upload", icon: "bx bx-upload" };
            }
            return "<span class=spDTIcon>" +
              "<i class='bx bx-download' title='Download' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='downloadPopup';" + "$('#btnDownloadDT').trigger('click');></i>" +
              "<i class='bx bx-upload' title='Upload' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='uploadPopup';" + "$('#btnUploadDT').trigger('click');></i>" +
              "<i class='bx bx-info-circle' title='Info' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='ipopup';" +
              "$('#btnPopupDT').trigger('click');></i>" +
              "</span>";
          }
        });
      }
      else if (val.ColumnReturnData == 'DownloadUpload') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Download') > -1) {
              contextitem['download'] = { name: "Download", icon: "bx bx-download" };
            }
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Upload') > -1) {
              contextitem['upload'] = { name: "Upload", icon: "bx bx-upload" };
            }
            return "<span class=spDTIcon>" +
              "<i class='bx bx-download' title='Download' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='downloadPopup';" + "$('#btnDownloadDT').trigger('click');></i>" +
              "<i class='bx bx-upload' title='Upload' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='uploadPopup';" + "$('#btnUploadDT').trigger('click');></i>" +
              "</span>";
          }
        });
      }
      else if (val.ColumnReturnData == 'DownloadEdit') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Download') > -1) {
              contextitem['download'] = { name: "Download", icon: "bx bx-download" };
            }
            if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Upload') > -1) {
              contextitem['upload'] = { name: "Upload", icon: "bx bx-upload" };
            }
            return "<span class=spDTIcon>" +
              "<i class='bx bx-download' title='Download' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "$('#btnDownloadDT').trigger('click');></i>" +
              "<i class='bx bxs-edit-alt' title='Edit' style='color:#34c38f;font-size:20px;' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "$('#BtnPopup').trigger('click');></i>" +
              "</span>";
          }
        });
      }
      else if (val.ColumnReturnData == 'Allocate') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            return "<span class=spDTIcon>" +
              "<i class='bx bx-paper-plane' title='Allocate' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "$('#btnAllocate').trigger('click');></i>" +
              "</span>";
          }
        });
      }
      else if (val.ColumnReturnData == 'AllocateRevert') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {

            //Skip Actios for Allocated users
            if (full['UserName'] != null) {
              return '--';
            }

            return "<span class=spDTIcon>" +
              "<i class='bx bx-paper-plane' title='Allocate' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "$('#btnAllocate').trigger('click');></i>" +
              "<i class='bx bx-paste' title='Send to Vendor' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "$('#btnSendtoVendor').trigger('click');></i>" +
              "</span>";
          }
        });
      }
      else if (val.ColumnReturnData == 'StartDownloadUpload') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            if (full['Status'] == 'Ready') {
              return "<span class=spDTIcon>" +
                "<i class='bx bx-download' title='Download' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';localStorage.clicktype='downloadPopup';" + "$('#btnDownloadDT').trigger('click');></i>" +
                "<i class='fa fa-play' title='Start' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';$('#btnStart').trigger('click');></i>" +
                "<i class='fa fa-times' title='Revert' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='ipopup';" +
                "$('#btnDeleteDT').trigger('click');></i>" +
                "</span>";
            }
            else {
              if (full["Status"] == 'Inprogress') {
                return "<span class=spDTIcon>" +
                  "<i class='bx bx-download' title='Download' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';localStorage.clicktype='downloadPopup';" + "$('#btnDownloadDT').trigger('click');></i>" +
                  "<i class='bx bx-upload' title='Upload' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';localStorage.clicktype='uploadPopup';" + "$('#btnUploadDT').trigger('click');></i>" +
                  "<i class='fa fa-times' title='Revert' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='ipopup';" +
                  "$('#btnDeleteDT').trigger('click');></i>" +
                  "</span>";

              } else {
                return "---";
              }
            }
            //if (full['Status'] == 'Completed') {
            //  return "<i class='fa fa-play' title='Start' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';$('#btnStart').trigger('click');></i>";
            //}
            //else {// if (full["Status"] == "InProcess")
            //  if (full["UpdatedBy"] == localStorage.aLoginID) {
            //    if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Download') > -1) {
            //      contextitem['download'] = { name: "Download", icon: "bx bx-download" };
            //    }
            //    if (paramItem.acolList[0].GridActionsItems.toString().indexOf('Upload') > -1) {
            //      contextitem['upload'] = { name: "Upload", icon: "bx bx-upload" };
            //    }
            //    return "<span class=spDTIcon>" +
            //      "<i class='bx bx-download' title='Download' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + + "localStorage.clicktype='downloadPopup';" + "$('#btnDownloadDT').trigger('click');></i>" +
            //      "<i class='bx bx-upload' title='Upload' data-col='" + data + "' onclick=localStorage.aEID='" + data + "';" + "localStorage.clicktype='uploadPopup';" + "$('#btnUploadDT').trigger('click');></i>" +
            //      "</span>";
            //  } else {
            //    return "---";
            //  }
            //}
          }
        });
      }
      else if (val.ColumnReturnData == 'Dropdown') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            if (full[val.ColumnData] != '' && full[val.ColumnData] != null) {

              if (val.ColumnData == 'UserList') {
                if (full['UserName'] != null)
                  return full['UserName'];
              }
              let userList = full[val.ColumnData].split(',');
              let dropList = '<select name="gridDrop" class="form-select select2" data-colname="' + val.ColumnData + '" >';
              dropList += '<option value="Select">Select</option>';
              $.each(userList, function (index, valitem) {
                let dataval = valitem.split('|');
                if (dataval.length == 2)
                  dropList += '<option value="' + dataval[1].trim() + '">' + dataval[0].trim() + '</option>';
              });
              dropList += '</select>';
              return dropList;

            }
            else {
              return '---';
            }


          }
        });
        exprtcol.push(e);
      }
      else if (val.ColumnReturnData == 'Textbox') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            return '<input type="text" id="' + val.ColumnTitle + '" class="gridTextbox" value="' + data + '" data-idavalue="' + full[paramItem.infoPopupID] + '"/>';
          }
        });
        exprtcol.push(e);
      }
      else if (val.ColumnReturnData == 'Datefield') { //Datefield New //
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            if (data == null) {
              return `<input type="date" class="datepicker form-group" id="${val.ColumnTitle}" data-idavalue=" ${full[paramItem.infoPopupID]}"/>`;
            }
            else {
              return `<input type="date" class="datepicker form-group" id="${val.ColumnTitle}" min="${customfunctions.dataformat(data)}" value="${customfunctions.dataformat(data)}" data-idavalue="${full[paramItem.infoPopupID]}"/>`;
            }
          }
        });
        exprtcol.push(e);
      }
      else if (val.ColumnReturnData == 'NullDatefield') { //Datefield New //
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            if (data == null) {
              let currentDate = customfunctions.CurrentDate();
              return `<input type="date" class="datepicker form-group" id="${val.ColumnTitle}"
               min="${currentDate}" data-idavalue=" ${full[paramItem.infoPopupID]}"/>`;
            }
            else {
              return GlobalConstants.FromateDateWithTime(data);
            }
          }
        });
        exprtcol.push(e);
      }
      else if (val.ColumnReturnData == 'DropdownYesNo') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            let chkStatus = (full[val.ColumnData] ? 'checked' : '');
            let chkYesNo = '<label class="switch">';
            chkYesNo += '<input type="checkbox" ' + chkStatus + ' name="gridDropYesNo" data-colname="' + val.ColumnData + '" data-idavalue="' + full[paramItem.infoPopupID] + '">';
            chkYesNo += '<span class="slider round"></span>';
            chkYesNo += '</label>';
            let chkVal = '<span style="display:none">' + chkStatus + '</span>';
            return chkVal + chkYesNo;
          }
        });
        exprtcol.push(e);
      }
      else if (val.ColumnReturnData == 'DropdownYesNoSelect') {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            let chkStatus = '';

            let chkYesNo = '<label class="switch">';
            chkYesNo += '<input type="checkbox" ' + chkStatus + ' name="gridDropYesNoSelect" data-colname="' + val.ColumnData + '" data-idavalue="' + full[paramItem.infoPopupID] + '">';
            chkYesNo += '<span class="slider round"></span>';
            chkYesNo += '</label>';
            let chkVal = '<span style="display:none">' + chkStatus + '</span>';
            return chkVal + chkYesNo;
          }
        });
        exprtcol.push(e);
      }
      else if (val.Actions == 0) {
        columnsList.push({
          title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
          render: function (data, type, full, meta) {
            if (val.ColumnDataType == 'datetime') {
              return GlobalConstants.FormatDate(data);
            }
            else if (val.ColumnDataType == 'datewithtime') {
              return GlobalConstants.FromateDateWithTime(data);
            }
            else {
              let dataVal: string = (data == null ? '' : data.toString());
              if (dataVal == 'true')
                return 'Yes';
              else if (dataVal == 'false')
                return 'No';
              else
                return data;
            }
          }
        });
        if (val.ColumnDataType == 'datetime') {
          datetimecolumnsList.push(e);
        }
        exprtcol.push(e);
      }
      else {

        if (paramItem.aNewButtonName == 'btn_QAResponse') {

          columnsList.push({
            title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
            render: function (data, type, full, meta) {
              let dataTitle = 'Response'; let colorCode = '#34c38f'; let readonly = '';
              return `
              <span class="spQAResponse">
                  <span class="text-success p-1">
                      <i
                          class="bx bx-message"
                          style="color:${colorCode}; font-size:20px;cursor:pointer"
                          title="${dataTitle}"
                          data-col="${data}"
                          onclick="${readonly}localStorage.dtColName='${val.ColumnData}';
                          localStorage.aEID='${data}'; $('#${paramItem.aNewButtonName}').trigger('click');">
                      </i>
                  </span>
              </span>`;
            }
          });

        }
        else {
          // Dynamic Columns Actions item
          if (val.ActionsItems.toString().trim() == 'View') {
            columnsList.push({
              title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
              render: function (data, type, full, meta) {
                localStorage.metadataEdit = false;
                return 'NA';
              }
            });
          }
        }
        if (val.ActionsItems.toString().indexOf('Update') > -1) {
          if (paramItem.isDefault) {
            localStorage.metadataEdit = true;
            columnsList.push({
              title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
              render: function (data, type, full, meta) {
                let dataTitle = 'Edit'; let colorCode = '#34c38f'; let readonly = '';
                if (full["ToolTipMessage"] != null) {
                  dataTitle = full["ToolTipMessage"];
                  colorCode = '#1e79b1'; //set grayout
                  readonly = "localStorage.metadisable=false;";
                }
                if (full.IsDefault) {
                  return "<span class=spUpdateIcon>" +
                    "<i class='bx bx-info-circle' style='color: #3e6bcc; font-size: 20px;' title='Info' data-col='" + data + "' onclick=localStorage.aEID=" + data + ";$('#btnInfoDT').trigger('click');></i></span>";
                }
                else if (val.ActionsItems.toString().indexOf('Delete') > -1) {
                  if (val.ActionsItems.toString().indexOf('Clone') > -1) {
                    return '<span class=spUpdateIcon>'
                      + "<span class='text-success p-1'><i class='bx bx-paste' style='color: #152ca3; font-size: 20px;'title='Clone Data' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#btnClone').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-danger p-1'><i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;' title='Delete' data-col='" + data + "' onclick=localStorage.aEID=" + data + ";$('#btnDeleteDT').trigger('click');></i></span>"
                      + "</span>";
                  }
                  else {
                    return '<span class=spUpdateIcon>'
                      + "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-danger p-1'><i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;' title='Delete' data-col='" + data + "' onclick=localStorage.aEID=" + data + ";$('#btnDeleteDT').trigger('click');></i></span>"
                      + "</span>";
                  }

                }
                else if (val.ActionsItems.toString().indexOf('UpdateAction') > -1) {
                  if (val.ActionsItems.toString().indexOf('Clone') > -1) {
                    return '<span class=spUpdateIcon>'
                      + "<span class='text-success p-1'><i class='bx bx-paste' style='color: #152ca3; font-size: 20px;'title='Clone Data' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#btnClone').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-success p-1'><i class='bx bx-edit' style='color: " + colorCode + "; font-size: 20px;' title='Modify' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#btnModify').trigger('click');></i></span>&nbsp;"
                      + "</span>";
                  }
                  else {
                    return '<span class=spUpdateIcon>'
                      + "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-success p-1'><i class='bx bx-edit' style='color: " + colorCode + "; font-size: 20px;' title='Modify' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#btnModify').trigger('click');></i></span>&nbsp;"
                      + "</span>";
                  }

                }
                else {
                  if (val.ActionsItems.toString().indexOf('Clone') > -1) {
                    return "<span class=spUpdateIcon>"
                      + "<span class='text-success p-1'><i class='bx bx-paste' style='color: #152ca3; font-size: 20px;'title='Clone Data' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#btnClone').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>"
                      + "</span>";
                  }
                  else {
                    return "<span class=spUpdateIcon>" +
                      "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>"
                      + "</span>";
                  }

                }
              }
            });
          }
          else {
            columnsList.push({
              title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
              render: function (data, type, full, meta) {

                let dataTitle = 'Edit'; let colorCode = '#34c38f'; let readonly = '';
                if (full["ToolTipMessage"] != null) {
                  dataTitle = full["ToolTipMessage"];
                  colorCode = '#1e79b1'; //set grayout
                  readonly = "localStorage.metadisable=false;";
                }
                if (val.ActionsItems.toString().indexOf('Delete') > -1) {
                  if (val.ActionsItems.toString().indexOf('Clone') > -1) {
                    return '<span class=spUpdateIcon>'
                      + "<span class='text-success p-1'><i class='bx bx-paste' style='color: #152ca3; font-size: 20px;'title='Clone Data' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#btnClone').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-danger p-1'><i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;' title='Delete' data-col='" + data + "' onclick=localStorage.aEID=" + data + ";$('#btnDeleteDT').trigger('click');></i></span>"
                      + "</span>";
                  }
                  else {
                    return '<span class=spUpdateIcon>'
                      + "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-danger p-1'><i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;' title='Delete' data-col='" + data + "' onclick=localStorage.aEID=" + data + ";$('#btnDeleteDT').trigger('click');></i></span>"
                      + "</span>";
                  }
                }
                else if (val.ActionsItems.toString().indexOf('UpdateAction') > -1) {
                  if (val.ActionsItems.toString().indexOf('Clone') > -1) {
                    return '<span class=spUpdateIcon>'
                      + "<span class='text-success p-1'><i class='bx bx-paste' style='color: #152ca3; font-size: 20px;'title='Clone Data' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#btnClone').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-success p-1'><i class='bx bx-edit' style='color: " + colorCode + "; font-size: 20px;' title='Modify' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#btnModify').trigger('click');></i></span>&nbsp;"
                      + "</span>";
                  }
                  else {
                    if (val.ActionsItems.toString().indexOf('Clone') > -1) {
                      return '<span class=spUpdateIcon>'
                        + "<span class='text-success p-1'><i class='bx bx-paste' style='color: #152ca3; font-size: 20px;'title='Clone Data' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#btnClone').trigger('click');></i></span>&nbsp;"
                        + "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>&nbsp;"
                        + "<span class='text-success p-1'><i class='bx bx-edit' style='color: " + colorCode + "; font-size: 20px;' title='Modify' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#btnModify').trigger('click');></i></span>&nbsp;"
                        + "</span>";
                    }
                    else {
                      return '<span class=spUpdateIcon>'
                        + "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>&nbsp;"
                        + "<span class='text-success p-1'><i class='bx bx-edit' style='color: " + colorCode + "; font-size: 20px;' title='Modify' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#btnModify').trigger('click');></i></span>&nbsp;"
                        + "</span>";
                    }

                  }
                }
                else if (val.ActionsItems.toString().indexOf('Paperplan') > -1) {  /* Newly added Icon paperplan and Heart*/
                  return "<span class=spUpdateIcon>" +
                    "<span class='text-success p-1'><i class='bx bx-paper-plane' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>"
                    + "</span>";

                }
                else if (val.ActionsItems.toString().indexOf('Heart') > -1) {
                  return "<span class=spUpdateIcon>" +
                    "<span class='text-success p-1'><i class='bx bxs-heart text-danger' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>"
                    + "</span>";
                }
                else {
                  if (val.ActionsItems.toString().indexOf('Clone') > -1) {
                    return "<span class=spUpdateIcon>"
                      + "<span class='text-warning p-1'><i class='bx bx-paste' style='color: #152ca3; font-size: 20px;'title='Clone Data' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#btnClone').trigger('click');></i></span>&nbsp;"
                      + "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>"
                      + "</span>";
                  }
                  else {
                    return "<span class=spUpdateIcon>"
                      + "<span class='text-success p-1'><i class='bx bxs-edit-alt' style='color: " + colorCode + "; font-size: 20px;' title='" + dataTitle + "' data-col='" + data + "' onclick=" + readonly + "localStorage.dtColName='" + val.ColumnData + "';" + "localStorage.aEID=" + data + ";$('#" + paramItem.aNewButtonName + "').trigger('click');></i></span>"
                      + "</span>";
                  }
                }
              }
            });
          }
        }
        else {
          if (val.ColumnTitle != 'Action') {
            columnsList.push({
              title: val.ColumnTitle, data: val.ColumnData, Sortable: val.Sortable, "visible": val.Visible,
              render: function (data, type, full, meta) {
                let dataVal: string = (data == null ? '' : data.toString());
                if (dataVal == 'true')
                  return 'Yes';
                else if (dataVal == 'false')
                  return 'No';
                else
                  return data;
              }
            });
            exprtcol.push(e);
          }
        }
      }

      //Columns Alignment allocate
      try {
        if (showGridSNo) {
          if (val.Alignment == 'center')
            colcenterList.push((e + 1));
          if (val.Alignment == 'right')
            colrightList.push((e + 1));
        }
        else {
          if (val.Alignment == 'center')
            colcenterList.push(e);
          if (val.Alignment == 'right')
            colrightList.push(e);
        }

      } catch (ex) {
        console.log(ex);
      }

    });

    let exportFormat = {
      body: function (inner, rowidx, colidx, node) {
        if ($(node).children("select").length > 0) {
          var selectNode = node.firstElementChild;
          var txt = selectNode.options[selectNode.selectedIndex].text;
          return txt;
        }
        else if ($(node).children('label').length > 0) {
          var checkNode = $(node).find('input[type="checkbox"]');
          if ($(checkNode).prop('checked'))
            return 'Yes';
          else
            return 'No';
        }
        else if ($(node).children("span").length > 0) {
          return $(inner).text();
        }
        else {
          return inner; // the standard cell contents
        }
      }
    }

    let exportFileName = paramItem.acolList[0].ModuleName + '_' + GlobalConstants.CurrentDateWithTime();
    if (paramItem.ExportFileName != "") {
      exportFileName = paramItem.ExportFileName + '_' + GlobalConstants.CurrentDateWithTime();
    }
    if (paramItem.acolList[0].ExportExcel == 1) {
      buttonList.push({
        extend: 'excelHtml5',
        text: '<img src="assets/Images/excel.png" title="Export to Excel" />',
        filename: exportFileName,
        title: paramItem.acolList[0].ModuleName,
        exportOptions: {
          columns: ':visible',
          format: exportFormat
        }
      });
    }
    if (paramItem.acolList[0].ExportPDF == 1) {
      buttonList.push({
        extend: 'pdfHtml5',
        text: '<img src="assets/Images/pdf.png" title="Export to PDF" />',
        filename: exportFileName,
        title: paramItem.acolList[0].ModuleName,
        orientation: 'landscape',
        pageSize: 'LEGAL',
        exportOptions: {
          columns: exprtcol,
          format: exportFormat
        }
      });
    }
    if (paramItem.acolList[0].ExportCSV == 1) {
      buttonList.push({
        extend: 'csvHtml5',
        text: '<img src="assets/Images/csv.png" title="Export to CSV" />',
        filename: exportFileName,
        title: paramItem.acolList[0].ModuleName,
        exportOptions: {
          columns: ':visible',
          format: exportFormat
        }
      });
    }
    if (paramItem.acolList[0].ActionsItems.toString().indexOf('Add') > -1) {
      buttonList.push({
        text: '<button class="btn btn-outline-info waves-effect waves-light spAddIcon" title="Add new item"><i class="fa fa-plus"></i></button>',
        action: function (e, dt, node, config) {
          localStorage.aEID = 0;
          $("#" + paramItem.aNewButtonName).trigger("click");
        }
      });
    }
    if (paramItem.colsetting) {
      //Column Options 
      buttonList.push({
        text: '<button class="btn btn-outline-info waves-effect waves-light spAddIcon" title="Column Options" id="btnColOption"><i class="fa fa-wrench"></i></button>',
        action: function (e, dt, node, config) {
          $("#btnShowCO").trigger("click");
        }
      });
    }
    if (paramItem.filterPanel) {
      //Filter Panel Options 
      buttonList.push({
        text: `<button class= "btn btn-outline-info waves-effect waves-light spAddIcon" title="Show Filter">
        <i class="fa fa-filter"></i></button >`,
        action: function (e, dt, node, config) {
          $("#btnFilterPanel").trigger("click");
        }
      });
    }
    //Load Refresh button
    if ($("#btnLoadList").length > 0 && paramItem.HideFreshButton == false) {
      //Column Options 
      buttonList.push({
        text: '<button class="btn btn-outline-info waves-effect waves-light" title="Refresh"><i class="fa fa-retweet"></i></button>',
        action: function (e, dt, node, config) {
          $("#btnLoadList").trigger("click");
        }
      });
    }

    //Import Data button
    if ($("#btnImportData").length > 0) {
      //Column Options 
      buttonList.push({
        text: '<button class="btn btn-outline-info waves-effect waves-light" title="Import Data"><i class="fa fa-file-import"></i></button>',
        action: function (e, dt, node, config) {
          $("#btnImportData").trigger("click");
        }
      });
    }

    if (paramItem.acolList[0].ActionsItems.toString().indexOf('Allocate') > -1) {
      let toolTitle = paramItem.aNewButtonToolTip == null ? "Allocate" : paramItem.aNewButtonToolTip.toString();
      buttonList.push({
        text: "<button class='btn btn-outline-info waves-effect waves-light spAddIcon' title='" + toolTitle + "'><i class='fa fa-paper-plane'></i></button>",
        action: function (e, dt, node, config) {
          localStorage.aEID = 0;
          $("#" + paramItem.aNewButtonName).trigger("click");
        }
      });
    }
    if (paramItem.acolList[0].ActionsItems.toString().indexOf('SendtoVendor') > -1) {
      let toolTitle = paramItem.aNewButtonToolTip1 == null ? "Send to Vendor" : paramItem.aNewButtonToolTip1.toString();
      buttonList.push({
        text: "<button class='btn btn-outline-info waves-effect waves-light spAddIcon' title='" + toolTitle + "'><i class='fa fa-paste'></i></button>",
        action: function (e, dt, node, config) {
          localStorage.aEID = 0;
          $("#" + paramItem.aNewButtonName1).trigger("click");
        }
      });
    }
    //if (paramItem.acolList[0].ActionsItems.toString().indexOf('MultipleAllocate') > -1) {
    //  let toolTitle = paramItem.aNewButtonToolTip2 == null ? "Load Excel" : paramItem.aNewButtonToolTip2.toString();
    //  buttonList.push({
    //    text: "<button class='btn btn-outline-info waves-effect waves-light spAddIcon' title='" + toolTitle + "'><i class='fa fa-upload'></i></button>",
    //    action: function (e, dt, node, config) {
    //      localStorage.aEID = 0;
    //      $("#" + paramItem.aNewButtonName2).trigger("click");
    //    }
    //  });
    //}
    if (paramItem.acolList[0].ActionsItems.toString().indexOf('AutoAllocate') > -1) {
      let toolTitle = paramItem.aNewButtonToolTip3 == null ? "Auto Allocation" : paramItem.aNewButtonToolTip3.toString();
      buttonList.push({
        text: "<button class='btn btn-outline-info waves-effect waves-light spAddIcon' title='" + toolTitle + "'><i class='fa fa-recycle'></i></button>",
        action: function (e, dt, node, config) {
          localStorage.aEID = 0;
          $("#" + paramItem.aNewButtonName3).trigger("click");
        }
      });
    }
    if (paramItem.aNewButtonToolTip2 != null) {
      let toolTitle = paramItem.aNewButtonToolTip2 == null ? "Load Excel" : paramItem.aNewButtonToolTip2.toString();
      buttonList.push({
        text: "<button class='btn btn-outline-info waves-effect waves-light spAddIcon' title='" + toolTitle + "'><i class='fa fa-upload'></i></button>",
        action: function (e, dt, node, config) {
          localStorage.aEID = 0;
          $("#" + paramItem.aNewButtonName2).trigger("click");
        }
      });
    }
    if (paramItem.acolList[0].ActionsItems.toString().indexOf('ExcelUpload') > -1 && paramItem.HideUploadButton == false) {
      let toolTitle = paramItem.aNewButtonToolTip == null ? "Upload Excel file" : paramItem.aNewButtonToolTip.toString();
      buttonList.push({
        text: "<button class='btn btn-outline-info waves-effect waves-light spAddIcon' title='" + toolTitle + "'><i class='fa fa-upload'></i></button>",
        action: function (e, dt, node, config) {
          localStorage.aEID = 0;
          $("#" + paramItem.aNewButtonName).trigger("click");
        }
      });
    }
    //Search button enable
    let domItem = 'RlBfrtip';
    if (!paramItem.searchButton) {
      //Search button disable
      domItem = 'Rlt';
    }

    paramItem.dataTable.on('error.dt', function (e, settings, techNote, message) {
      console.log('An error has been reported: ', message);
    });


    let _footerTrAdded: boolean = false;

    paramItem.dataTable = paramItem.dataTable.DataTable({
      dom: domItem,
      responsive: paramItem.ResponsiveMode,
      colReorder: true,
      rowReorder: true,
      stateSave: paramItem.StateSave,
      "pageLength": paramItem.defaultPagesize,
      "lengthMenu": [[10, 15, 25, 50, 75, 100, -1], [10, 15, 25, 50, 75, 100, "All"]],
      data: paramItem.dataset,
      columns: columnsList,
      columnDefs: [
        { type: 'date', targets: datetimecolumnsList },
        { className: "dt-head-center", targets: colcenterList },
        { className: "dt-head-right", targets: colrightList }
      ],
      "destroy": true,
      fixedHeader: {
        header: true
      },
      fixedColumns: {
        start: 1,
        end: 3
      },
      buttons: buttonList,
      paging: true,
      "scrollY": paramItem.dtheight,
      "scrollX": true,
      "lengthChange": paramItem.LengthChange,
      "language": {
        "search": "Search:"
      },
      //"order": [[1, paramItem.IdOrder]],
      "createdRow": function (row, data, dataIndex) {
        var chkRowHighlightOption = menuList.filter(a => a.MenuName == "GridRowHighlight");
        if (chkRowHighlightOption.length > 0) {
          if (chkRowHighlightOption[0].Action.toString() == 'View') {
            if (paramItem.modulename == "ArticleDetailsStatusHome" || paramItem.modulename == "IssueListModule") {
              $(row).addClass(data.StageCss);
            }
            else if (paramItem.modulename == "ArticleModule") {
              $(row).addClass(data.OverDueCSS);
            }
            else if (paramItem.modulename == "FreelancerModule") {
              $(row).addClass(data.Approve);
            }
            else if (paramItem.modulename == "EmpOccupancyEmpDatewise") {
              if (data.HighlightClass != "") {
                $(row).addClass(data.HighlightClass);
                if (data.HighlightClass != null) {
                  $(row).attr('title', data.HighlightClass.toUpperCase());
                }
              }
            }
            if (data.IsHold) {
              $(row).addClass('hold');
            }
            if (data.Rush) {
              $(row).addClass('rush');
            }
          }
        }
        if (data.HighlightedJournal) {
          $(row).addClass('rush');
        }
      },
      "drawCallback": function (row, data, dataIndex) {
        customfunctions.DropDownEventChange();
      },
      "footerCallback": function (tr, data, start, end, display) {
        try {

          if (paramItem.FooterCallback == true) {

            var colCount = paramItem.acolList.length;
            var startIndex = paramItem.FooterSummaryStartIndex;
            var endIndex = paramItem.FooterSummaryEndIndex;

            var api = this.api();
            var footer = $(this).append('<tfoot><tr></tr></tfoot>');
            let _colLength = paramItem.acolList.length;
            let _sumCol = $('table th.tblFooter').length;
            if (showGridSNo) {
              _sumCol = _sumCol - 1;
            }
            if (_sumCol == _colLength) {
              $('.tblFooter').remove();
            }
            let _rowCount = 0;
            api.columns().every(function (index, val) {
              if (index > startIndex && index <= endIndex) {
                var column = this;
                var sum = column
                  .data()
                  .reduce(function (a, b) {
                    var x = parseFloat(a) || 0;
                    var y = parseFloat(b) || 0;
                    return x + y;
                  }, 0);

                var columnData = this.data();
                var total = columnData.reduce((a, b) => (parseFloat(a) || 0) + (parseFloat(b) || 0), 0);
                var count = columnData.filter(val => !isNaN(parseFloat(val))).length;
                var average = count > 0 ? (total / count).toFixed(2) : 0;

                if (index >= paramItem.FooterSummaryAvgStart && index <= paramItem.FooterSummaryAvgEnd) {
                  $(footer).append('<th class="tblFooter text-center">' + average + '</th>');
                }
                else {
                  $(footer).append('<th class="tblFooter text-center">' + sum + '</th>');
                }

              }
              else {
                if (index == startIndex) {
                  $(footer).append('<th class="tblFooter text-center">Total</th>');
                }
                else {
                  $(footer).append('<th class="tblFooter"></th>');
                }
              }
              _rowCount++;
            });

          }

        } catch (e) {
          console.log(e);
        }
      }
    });

    customfunctions.SetTheme(localStorage.UserThemes, true);

    //if (paramItem.ResponsiveMode) {

    paramItem.dataTable.on('column-reorder', function (e, settings, details) {
      customfunctions.ColumnOrderSave(paramItem.dataTable, paramItem.modulename);
    });

    paramItem.dataTable.on('responsive-display', function (e, datatable, row, showHide, update) {
      customfunctions.DropDownEventChange();
    });
    //}

    if (paramItem.rowSelect) {
      $('table.dataTable tbody').off().on('click', 'tr', function (e) {
        if (e.target.tagName == 'TD')
          $(this).toggleClass('selected');
      });
    }

    if (paramItem.acolList[0].ActionsItems.toString().indexOf('Add') > -1) {
      contextitem['add'] = { name: "Add", icon: "add" };
    }
    if (paramItem.acolList[0].ActionsItems.toString().indexOf('Update') > -1) {
      contextitem['update'] = { name: "Update", icon: "edit" };
    }
    if (paramItem.acolList[0].ActionsItems.toString().indexOf('Delete') > -1) {
      contextitem['delete'] = { name: "Delete", icon: "delete" };
    }
    if (paramItem.acolList[0].ExportExcel == 1) {
      contextitem['excel'] = { name: "Export to excel", icon: "fa-file-excel" };
    }
    if (paramItem.acolList[0].ExportPDF == 1) {
      contextitem['pdf'] = { name: "Export to PDF", icon: "fa-file-pdf" };
    }
    if (paramItem.acolList[0].ExportCSV == 1) {
      contextitem['csv'] = { name: "Export to CSV", icon: "fa-file-text" };
    }

    if (paramItem.contextMenu) {
      try {
        $.contextMenu({
          selector: "table.dataTable tbody tr",
          callback: function (key, options) {
            let dataId = 0;
            if (paramItem.aNewButtonName != '') {
              if (key == 'add') {
                localStorage.aEID = 0;
                $("#" + paramItem.aNewButtonName).trigger("click");
              }
              else if (key == 'update') {
                if ($(this).find('i[class="bx bxs-edit-alt"]').length != 0) {
                  dataId = $(this).find('i[class="bx bxs-edit-alt"]').attr('data-col');
                  localStorage.aEID = dataId;
                  $("#" + paramItem.aNewButtonName).trigger("click");
                }
              }
              else if (key == 'delete') {
                if ($(this).find('i[class="bx bxs-trash"]').length != 0) {
                  dataId = $(this).find('i[class="bx bxs-trash"]').attr('data-col');
                  localStorage.aEID = dataId;
                  $("#btnDeleteDT").trigger("click");
                }
              }
            }
            if (key == 'download') {
              if ($(this).find('i[class="bx bx-download"]').length != 0) {
                dataId = $(this).find('i[class="bx bx-download"]').attr('data-col');
                localStorage.aEID = dataId;
                let multiSelect = $('table.dataTable tbody tr.selected');
                if (multiSelect.length > 0) {
                  let dataIdList = '';
                  $.each(multiSelect, function (e, val) {
                    dataIdList += $(this).find('i[class="bx bx-download"]').attr('data-col') + ',';
                  });
                  localStorage.aEID = dataIdList.replace(/,\s*$/, "");
                }
                $('#btnDownloadDT').trigger('click');
              }
            }
            else if (key == 'upload') {
              if ($(this).find('i[class="bx bx-upload"]').length != 0) {
                dataId = $(this).find('i[class="bx bx-upload"]').attr('data-col');
                localStorage.aEID = dataId;
                $('#btnUploadDT').trigger('click');
              }
            }
            else if (key == 'excel') {
              paramItem.dataTable.buttons(0).trigger();
            }
            else if (key == 'pdf') {
              paramItem.dataTable.buttons(1).trigger();
            }
            else if (key == 'csv') {
              paramItem.dataTable.buttons(2).trigger();
            }
          },
          items: contextitem
        });
      } catch (e) {

      }
    }
    GlobalConstants.resetStorage();
    this.DropDownEventChange();
    this.DatePickerEventChange();
    return paramItem.dataTable;
  }

  /*DatePicker on change New*/
  public static DatePickerEventChange() {
    $('.datepicker').change(function () {
      localStorage.datepickerId = $(this).val();
      let row = $(this).closest('tr');
      var rowId = row.index();
      localStorage.rowIdVal = rowId + 1;
      localStorage.colName = $(this).data('colname');
      localStorage.colNameValue = ($(this).val() == "1" ? "true" : "false");
      $('#btnDropChange').trigger('click');

    });
  }

  public static DropDownEventChange() {
    $('select[name="gridDrop"]').change(function () {
      localStorage.dropId = $(this).val();
      localStorage.rowIdVal = $(this).data('idavalue');

      let row = $(this).closest('tr');
      var rowId = row.index();
      localStorage.rowIdVal = rowId + 1;

      localStorage.colName = $(this).data('colname');
      localStorage.colNameValue = ($(this).val() == "1" ? "true" : "false");
      $('#btnDropChange').trigger('click');
    });

    $('input[name="gridDropYesNo"]').change(function () {
      if ($(this).is(":checked"))
        localStorage.dropId = '1';
      else
        localStorage.dropId = '0';
      localStorage.rowIdVal = $(this).data('idavalue');
      localStorage.colName = $(this).data('colname');
      localStorage.colNameValue = (localStorage.dropId == "1" ? "true" : "false");
      $('#btnDropChange').trigger('click');
    });

    $('input[name="gridDropYesNoSelect"]').change(function () {
      if ($(this).is(":checked")) {
        localStorage.dropId = '1';
        localStorage.selectRowIdVal += $(this).data('idavalue') + '|';
      }
      else {
        localStorage.selectRowIdVal = localStorage.selectRowIdVal.toString().replace($(this).data('idavalue') + '|', '');
      }
    });

    $('input[name="gridDropSelectAll"]').change(function () {
      if ($(this).is(":checked")) {
        $('input[name="gridDropYesNoSelect"]').prop('checked', true);
      }
      else {
        $('input[name="gridDropYesNoSelect"]').prop('checked', false);
      }

      let ids = "";
      $('input[name="gridDropYesNoSelect"]:checked').each(function () {
        ids += $(this).data("idavalue") + "|";
      });

      localStorage.dropId = ids;
      localStorage.selectRowIdVal = ids;
    });

  }

  public static ColumnOrderSave(dataTable, modulename): void {
    let aord = dataTable.colReorder.order();
    let aOrderList = [];
    try {
      $(aord).each(function (index) {
        aOrderList.push({
          ColumnTitle: $(dataTable.header()).find('th')[index].innerText,
          DisplayOrder: index + 1
        });
      });
    } catch (e) {
      console.log(e);
    }

    if (modulename != '') {
      var aitemL = {
        LoginID: localStorage.aLoginID,
        PublisherID: localStorage.aPubID,
        ModuleName: modulename,
        OrderList: JSON.stringify(aOrderList)
      };
      ApiMethod.postMethod('gen/updatecolumnorder', aitemL).subscribe(
        resonse => {
          console.log(resonse);
        }
      );

    }
  }

  public static SetTheme(themeName, fromDB = false) {
    let sideClassList = 'main-sidebar sidebar-dark-primary elevation-4';
    if (themeName == 'Reset') {
      $($('aside')[0]).attr('class', sideClassList);
    }
    else {
      sideClassList += ' btn' + themeName;
      $($('aside')[0]).attr('class', sideClassList);

    }
    if (!fromDB) {
      var aitemL = {
        LoginID: localStorage.aLoginID,
        ThemesName: themeName,
      };
      ApiMethod.postMethod('gen/updateThemes', aitemL).subscribe(
        resonse => {
          localStorage.UserThemes = resonse;
        }
      );
    }
  }

  public static SetTodayDateValues(Dt, addDays = 0) {
    var now = new Date();
    now.setDate(now.getDate() + addDays);
    var currentDay = ("0" + now.getDate()).slice(-2);
    var currentMonth = ("0" + (now.getMonth() + 1)).slice(-2);
    var currentDate = now.getFullYear() + "-" + (currentMonth) + "-" + (currentDay);
    $(Dt).val(currentDate);

  }
  public static CurrentDate() {
    var date = new Date();
    var currentDate = date.toISOString().slice(0, 10);
    return currentDate;
  }

  public static dataformat(dt: string): string {
    let myDate: Date = new Date(dt);
    myDate.setDate(myDate.getDate());
    let formattedDate: string = myDate.toISOString().slice(0, 10);
    return formattedDate;
  }

  public static Set3MonthDateValues(FromDt, ToDt) {
    var now = new Date();

    var currentDay = ("0" + now.getDate()).slice(-2);
    var currentMonth = ("0" + (now.getMonth() + 1)).slice(-2);
    var currentDate = now.getFullYear() + "-" + (currentMonth) + "-" + (currentDay);
    $(ToDt).val(currentDate);

    var preDate = new Date(now.setDate(now.getDate() - 90));
    var prevDay = ("0" + (preDate.getDate())).slice(-2);
    var prevMonth = ("0" + (preDate.getMonth() + 1)).slice(-2);
    var prevToday = preDate.getFullYear() + "-" + (prevMonth) + "-" + (prevDay);
    $(FromDt).val(prevToday);

    //Set max date details
    $(FromDt).attr('max', currentDate);
    //Set min date details
    $(ToDt).attr('min', prevToday);

    $(FromDt).change(function () {
      let _fromDateMin = new Date($(FromDt).val());
      let _prevDay = ("0" + (_fromDateMin.getDate())).slice(-2);
      let _prevMonth = ("0" + (_fromDateMin.getMonth() + 1)).slice(-2);
      let _prevToday = _fromDateMin.getFullYear() + "-" + (_prevMonth) + "-" + (_prevDay);
      $(ToDt).attr('min', _prevToday);
    });
  }

  public static SetCurrentMonthDateValues(FromDt, ToDt) {
    var now = new Date();

    // Current month start date
    var firstDay = new Date(now.getFullYear(), now.getMonth(), 1);

    // Current month end date
    var lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    var fromDate =
      firstDay.getFullYear() + "-" +
      ("0" + (firstDay.getMonth() + 1)).slice(-2) + "-" +
      ("0" + firstDay.getDate()).slice(-2);

    var toDate =
      lastDay.getFullYear() + "-" +
      ("0" + (lastDay.getMonth() + 1)).slice(-2) + "-" +
      ("0" + lastDay.getDate()).slice(-2);

    $(FromDt).val(fromDate);
    $(ToDt).val(toDate);

    // Set max date for From Date
    $(FromDt).attr('max', toDate);

    // Set min date for To Date
    $(ToDt).attr('min', fromDate);

    $(FromDt).change(function () {
      var selectedFromDate = $(FromDt).val();

      // To date cannot be before From date
      $(ToDt).attr('min', selectedFromDate);
    });
  }

  public static SetDateValues(FromDt, ToDt) {
    var now = new Date();

    var currentDay = ("0" + now.getDate()).slice(-2);
    var currentMonth = ("0" + (now.getMonth() + 1)).slice(-2);
    var currentDate = now.getFullYear() + "-" + (currentMonth) + "-" + (currentDay);
    $(ToDt).val(currentDate);

    var preDate = new Date(now.setDate(now.getDate() - 30));
    var prevDay = ("0" + (preDate.getDate())).slice(-2);
    var prevMonth = ("0" + (preDate.getMonth() + 1)).slice(-2);
    var prevToday = preDate.getFullYear() + "-" + (prevMonth) + "-" + (prevDay);
    $(FromDt).val(prevToday);

    //Set max date details
    $(FromDt).attr('max', currentDate);
    //Set min date details
    $(ToDt).attr('min', prevToday);

    $(FromDt).change(function () {
      let _fromDateMin = new Date($(FromDt).val());
      let _prevDay = ("0" + (_fromDateMin.getDate())).slice(-2);
      let _prevMonth = ("0" + (_fromDateMin.getMonth() + 1)).slice(-2);
      let _prevToday = _fromDateMin.getFullYear() + "-" + (_prevMonth) + "-" + (_prevDay);
      $(ToDt).attr('min', _prevToday);
    });
  }


  public static SetDateValuesRangebased(fromDt, toDt, range, startVal = 0, endVal = 0) {
    let startDate: string; let endDate: string;

    var curr = new Date; // get current date
    var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    var last = first + 6; // last day is the first day + 6

    var firstday = new Date(curr.setDate(first));
    var lastday = new Date(curr.setDate(last));


    if (range == 'Monthly' || range == 'Custom') {
      let date = new Date();
      firstday = new Date(date.getFullYear(), date.getMonth(), 1);
      lastday = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }
    else if (range == 'Daily') {
      firstday = new Date();
      lastday = new Date();
    }
    else if (range == "Weekly") {
      firstday = new Date();
      firstday.setDate(firstday.getDate() - 5);
      lastday = new Date();
    }
    if (startVal != 0 && endVal != 0) {
      if (range == 'Monthly') {
        firstday.setMonth(startVal - 1);
        lastday.setMonth(endVal - 1);
      }
      else if (range == 'Yearly') {
        let date = new Date();
        firstday = new Date(date.getFullYear(), 0, 1);
        lastday = new Date(date.getFullYear(), 12, 0);

        firstday.setFullYear(startVal);
        lastday.setFullYear(endVal);
      }
    }

    var day = firstday.getDate();
    var dayString = day > 9 ? day : '0' + day;
    var month = (firstday.getMonth() + 1);
    var monthString = month > 9 ? month : '0' + month;
    startDate = firstday.getFullYear() + '-' + monthString + '-' + dayString;

    day = lastday.getDate();
    dayString = day > 9 ? day : '0' + day;
    month = (lastday.getMonth() + 1);
    monthString = month > 9 ? month : '0' + month;
    endDate = lastday.getFullYear() + '-' + monthString + '-' + dayString;

    $(fromDt).val(startDate);
    $(toDt).val(endDate);

  }

  public static Downloadfile(APIUrl) {
    let mywindow = window.open(APIUrl, "mywindow", "location=1,status=1,scrollbars=1,  width=500,height=200");
    mywindow.moveTo(500, 100);
  }

  public static DynamicHtmlDataBind(dyamicColList, dataSet) {
    let themName = localStorage.UserThemes;
    let itemL = dataSet;
    let ztable = "<tbody>";
    let firsttd = 'style="width: 25%;background: #c2d1f9;font-weight: bold;padding-left: 10px;border: 1px solid #c7c2c2;padding:5px;"';
    let tabletd = 'style="border: 1px solid #c7c2c2;padding:5px;"';

    let checkMetadaEdit = true;
    //Check Edit Action available for Metadata editing
    var menuList = JSON.parse(localStorage.aMenuList);
    var chkActionOption = menuList.filter(a => a.MenuName == "MetaData");
    if (chkActionOption.length == 0) {
      checkMetadaEdit = false;
    }
    else {
      if (chkActionOption[0].Action.toString() == 'View') {
        checkMetadaEdit = false;
      }
    }


    let dynamicCol = dyamicColList;
    $.each(dynamicCol, function (e, val) {
      let dataColNameBind = val.ColumnName;
      let dataBind = val.RenderDataRight;
      //if (GlobalConstants.isNullCheck(itemL[0][dataColNameBind]) != '' || val.MandatoryVisible == 'Yes') {
      if (val.ColumnDataType == 'string') {
        let dataBindVal = GlobalConstants.isNullCheck(itemL[0][dataColNameBind]).toString().trimEnd().replace(/[,;]$/, '');
        if (dataBindVal == 'true') {
          dataBindVal = 'Yes';
        }
        if (dataBindVal == 'false') {
          dataBindVal = 'No';
        }
        ztable += "<tr><td " + firsttd + ' class="btn' + themName + '">' + val.RenderDataLeft + '</td>'
          + "<td " + tabletd + ">" + dataBindVal + "</td></tr>";
      }
      if (val.ColumnDataType == 'date') {
        ztable += "<tr><td " + firsttd + ' class="btn' + themName + '">' + val.RenderDataLeft + '</td>'
          + "<td " + tabletd + ">" + GlobalConstants.FormatDate(itemL[0][dataColNameBind]) + "</td></tr>";
      }
      else if (val.ColumnDataType == 'span') {
        let inputRender = dataBind;
        inputRender = inputRender.replace('{Values}', GlobalConstants.isNullCheck(itemL[0][dataColNameBind]));
        ztable += "<tr><td " + firsttd + ' class="btn' + themName + '">' + val.RenderDataLeft + '</td>'
          + "<td " + tabletd + ">" + inputRender + "</td></tr>";
      }
      else if (val.ColumnDataType == 'inputbox') {
        let inputRender = dataBind;
        if (dataColNameBind == 'VolumeIssue') {
          if (itemL[0].IsApprove) {
            inputRender = itemL[0]["Volume"] + '/' + itemL[0]["Issue"]
          } else {
            inputRender = inputRender.replace('{Volume}', itemL[0]["Volume"]);
            inputRender = inputRender.replace('{Issue}', itemL[0]["Issue"]);
          }

          ztable += "<tr><td " + firsttd + ' class="btn' + themName + '">' + val.RenderDataLeft + '</td>'
            + "<td " + tabletd + ">" + inputRender + "</td></tr>";
        }
      }
      else if (val.ColumnDataType == 'checkbox') {
        let inputRender = dataBind;
        if (dataColNameBind == 'Hold') {
          inputRender = inputRender.replace('{checked}', (itemL[0].IsHold === 1 ? 'Yes' : 'No'));
          ztable += "<tr><td " + firsttd + ' class="btn' + themName + '">' + val.RenderDataLeft + '</td>'
            + "<td " + tabletd + ">" + inputRender + "</td></tr>";
        }
        else if (dataColNameBind == 'ManualClose') {
          inputRender = inputRender.replace('{checked}', (itemL[0].MannualClose === 1 ? 'Yes' : 'No'));

          ztable += "<tr><td " + firsttd + ' class="btn' + themName + '">' + val.RenderDataLeft + '</td>'
            + "<td " + tabletd + ">" + inputRender + "</td></tr>";
        }
        else if (dataColNameBind == 'SpecialIssue') {
          try {
            let leftRender = val.RenderDataLeft;
            themName = themName + ' ' + dataColNameBind;
            let siTitle = GlobalConstants.isNullCheck(itemL[0].SpecialIssueTitle);
            inputRender = inputRender.replace('{sititle}', siTitle);
            if (siTitle == '') {
              inputRender = inputRender.replace('checked', '');
            }
            if (itemL[0].SpecialIssue) {
              inputRender = inputRender.replace('disabled', '');
            }
            else {
              leftRender = leftRender.replace('checked', '');
            }

            ztable += "<tr><td " + firsttd + ' class="btn' + themName + '">' + leftRender + '</td>'
              + "<td " + tabletd + ">" + inputRender + "</td></tr>";

          } catch (ex) {
            console.log(ex);
          }

        }
      }
      //}
    });
    ztable += '</tbody>';
    return ztable;
  }

  public static FieldConfiguration(tableName) {
    let pubId = localStorage.aPubID;
    ApiMethod.getMethod('gen/FieldConfigList/' + tableName + '/0/' + pubId).subscribe(
      result => {
        let aFieldList = result.fieldList;
        if (localStorage.aEID != 0) {
          $(aFieldList).each(function (index, val) {
            const fieldName = val.TableField; // replace with the desired field name      
            const field = $("#" + fieldName + "").find('input, select, textarea').first(); //Get the field element
            const label = $("#" + fieldName + "").find("label");
            //if IsVisible is true show else hide that field
            if (val.IsVisible) {
              //changing field maxlength              
              $(field).find('input').attr('maxlength', val.CharLength);
              //if IsEditable is false field has been disabled 
              if (!val.IsEditable) {
                $(field).prop('disabled', true);   // Disable the field          
              }
              if (val.IsMandatory) {
                label.html(val.LabelName + "<span class='required'style='color: red !important'>*</span>");
                $(field).prop('required', true); // make the field required
              } else {
                label.html(val.LabelName);
              }
            } else {
              $("#" + fieldName + "").hide();  // Hide the field
            }
          });
        } else {
          $(aFieldList).each(function (index, val) {
            const fieldName = val.TableField; // replace with the desired field name      
            const field = $("#" + fieldName + "").find('input, select, textarea').first(); //Get the field element
            //if IsVisible is true show else hide that field
            if (val.IsVisible) {
              $(field).prop('disabled', false);   // Enable the field 
            }
          });
        }
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
}

